import Vue from 'vue'

export default {
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    type: localStorage.getItem('type') || null,
    token: localStorage.getItem('token') || null,
    remember: localStorage.getItem('remember') == 'true' || false,
    status: ''
  },
  getters: {
    isAuthenticated: state => !!state.token && !!state.user,
    remember: state => state.remember,
    authStatus: state => state.status,
    user: state => state.user,
    type: state => state.type
  },
  actions: {
    AUTH_LOGIN: ({commit, dispatch}, user) => {
      return new Promise((resolve, reject) => {
        commit('AUTH_REQUEST');

        Vue.http.post('api/Auth/Login', user).then(resp => {
          if(user.rememberMe)
          {
            commit('SET_REMEMBERME', user.rememberMe);
          }
          
          commit('SET_USER', resp.data.user);
          commit('SET_TYPE', resp.data.type);
          commit('AUTH_SUCCESS', resp.data.token);

          resolve(resp);
        })
        .catch(err => {
          commit('AUTH_ERROR', err)
          reject(err)
        });
      })
    },
    AUTH_LOGOUT: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        resolve();
        commit('AUTH_LOGOUT');
        return;
      })
    },
    GET_USER: ({commit, dispatch}, user) => {
      return new Promise((resolve, reject) => {
        if(user != null && user != '')
        {
          commit('SET_USER', user);
          resolve(user);
          return;
        } else {
          Vue.http.get('api/User').then((res) =>
          {
            commit('SET_USER', res.data);
            resolve(res.data);
            return;
          }).catch((err) =>
          {
            dispatch('AUTH_LOGOUT')
            reject();
            return;
          })
        }
      });
    }
  },
  mutations: {
    AUTH_REQUEST: (state) => {
      state.status = 'loading';
    },
    AUTH_SUCCESS: (state, token) => {
      state.status = 'success';
      state.token = token;
      Vue.http.headers.common['Authorization'] = 'Bearer ' + token;
      
      if(state.remember)
        localStorage.setItem('token', token);
    },
    AUTH_LOGOUT: (state) => {
      state.token = null;
      state.user = null;
      state.type = null;
      state.status = '';

      localStorage.removeItem('user');
      localStorage.removeItem('type');
      localStorage.removeItem('token');
      localStorage.removeItem('remember');

      setTimeout(() => {
        let app = document.getElementById("app"),
        footer = document.getElementById("theFooter");
  
        app.style.paddingBottom = footer.offsetHeight + 'px';
      }, 1)
      
    },
    AUTH_ERROR: (state) => {
      state.token = null;
      state.user = null;
      state.status = 'error';
      
      localStorage.removeItem('user');
      localStorage.removeItem('type');
      localStorage.removeItem('token');
      localStorage.removeItem('remember');
    },
    SET_REMEMBERME: (state, remember) => {
      state.remember = remember;
      
      if(remember)
        localStorage.setItem('remember', remember);
    },
    SET_USER: (state, user) => {
      state.user = user;
      
      if(state.remember)
        localStorage.setItem('user', JSON.stringify(user));
    },
    SET_TYPE: (state, type) => {
      state.type = type;
      
      if(state.remember)
        localStorage.setItem('type', type);
    }
  }
};
